angular.module('nv.SchoolMetricsModule').component('regentsMetricsTable', {
  template: require('./regents-metrics-table.html'),
  bindings: {
    changeMadeInMetrics: '=',
    cohort: '=',
    regentsTableCopy: '=',
  },
  controller: 'RegentsMetricsTableCtrl',
});
